// import React, { useEffect, useRef, useState } from "react";
// import {
//   formatBoldText,
//   formatBoldTextOlder,
// } from "../../../../../services/commonService";
// import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

// function ExecutiveSummaryNextSteps({ nextStepsData }) {
//   const colRefs = [useRef(null), useRef(null), useRef(null)];
//   const [data, setData] = useState([]);
//   const [isExpanded, setIsExpanded] = useState(false);

//   useEffect(() => {
//     setData(nextStepsData);
//   }, [nextStepsData]);

//   const handleToggleExpand = () => setIsExpanded((prev) => !prev);

//   return (
//     <>
//       <div className="company_overview_head_block">
//         <div className="compnay_subblock_left">
//           <h6 className="company_overview_head"></h6>
//           <p className="compnay_overview_para" style={{ maxWidth: "100%" }}></p>
//         </div>
//         {/* <TopRightActionLinks actions={actions} section_type="company" /> */}
//       </div>
//       <div className={`insight_block ${isExpanded ? "expanded" : "collapsed"}`}>
//         {<h5 className="insight_head">Executive Summary & Next Steps</h5>}
//         <div className="row">
//           {
//             <div className="col-md-12 mb-4">
//               <div className="card_block negative">
//                 <h6 className="head negative_head">
//                   Critical Decision Window: 6-18 Months
//                 </h6>
//                 {/* {nextStepsData?.response?.critical_decision_window?.length &&
//                   nextStepsData?.response?.critical_decision_window.map(
//                     (decision, index) => {
//                       return (
//                         <span
//                           key={index}
//                           style={{
//                             fontSize: "12px",
//                             fontWeight: "400",
//                           }}
//                         >
//                           {decision?.value}
//                         </span>
//                       );
//                     }
//                   )
//                   } */}
//                 <ul
//                   style={{
//                     fontSize: "12px",
//                     fontWeight: "400",
//                     textAlign: "left",
//                     paddingLeft: "0",
//                     marginBottom: "0px",
//                   }}
//                 >
//                   {data[0]?.response?.critical_decision_window?.length > 0 &&
//                     data[0]?.response?.critical_decision_window.map(
//                       (decision, index) => (
//                         <li
//                           key={index} // Add a unique key to each element
//                           style={{
//                             fontSize: "12px",
//                             fontWeight: "400",
//                           }}
//                         >
//                           {/* Accessing the 'value' key of each decision */}
//                           {decision?.value?.length > 0 &&
//                             formatBoldText(
//                               <ParsedTextWithLinks text={decision?.value} />
//                             )}
//                         </li>
//                       )
//                     )}
//                 </ul>
//               </div>
//             </div>
//           }

//           {
//             <div className="col-md-4">
//               <div className="card_block positive">
//                 <h6 className="head green_head">Market Opportunities</h6>
//                 <ul
//                   style={{
//                     fontSize: "12px",
//                     fontWeight: "400",
//                     textAlign: "left",
//                     paddingLeft: "0",
//                     marginBottom: "0px",
//                   }}
//                 >
//                   {data[0]?.response?.market_opportunities?.length > 0 &&
//                     data[0]?.response?.market_opportunities.map(
//                       (opportunities, index) => (
//                         <li className="mb-2">
//                           {opportunities?.value?.length > 0 &&
//                             formatBoldText(
//                               <ParsedTextWithLinks
//                                 text={opportunities?.value}
//                               />
//                             )}
//                         </li>
//                       )
//                     )}
//                 </ul>
//               </div>
//             </div>
//           }

//           {
//             <div className="col-md-4">
//               <div className="card_block neutral">
//                 <h6 className="head neutral_head">Defensive Measures</h6>
//                 <ul
//                   style={{
//                     fontSize: "12px",
//                     fontWeight: "400",
//                     textAlign: "left",
//                     paddingLeft: "0",
//                   }}
//                 >
//                   {data[0]?.response?.defensive_measures?.length > 0 &&
//                     data[0]?.response?.defensive_measures.map(
//                       (defensive_measure, index) => (
//                         <li className="mb-2">
//                           {defensive_measure?.value?.length > 0 &&
//                             formatBoldText(
//                               <ParsedTextWithLinks
//                                 text={defensive_measure?.value}
//                               />
//                             )}
//                         </li>
//                       )
//                     )}
//                 </ul>
//               </div>
//             </div>
//           }

//           {
//             <div className="col-md-4">
//               <div className="card_block negative">
//                 <h6 className="head negative_head">Intelligence Tracking</h6>
//                 <ul
//                   style={{
//                     fontSize: "12px",
//                     fontWeight: "400",
//                     textAlign: "left",
//                     paddingLeft: "0",
//                   }}
//                 >
//                   {data[0]?.response?.intelligence_tracking?.length > 0 &&
//                     data[0]?.response?.intelligence_tracking.map(
//                       (intelligence, index) => (
//                         <li className="mb-2">
//                           {intelligence?.value?.length > 0 &&
//                             formatBoldText(
//                               <ParsedTextWithLinks text={intelligence?.value} />
//                             )}
//                         </li>
//                       )
//                     )}
//                 </ul>
//               </div>
//             </div>
//           }
//         </div>
//       </div>
//     </>
//   );
// }

// export default ExecutiveSummaryNextSteps;

import React, { useEffect, useRef, useState } from "react";
import {
  formatBoldText,
  formatBoldTextOlder,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ExecutiveSummaryNextSteps({ nextStepsData }) {
  const colRefs = [useRef(null), useRef(null), useRef(null)];
  const [data, setData] = useState([]);
  const [expandedItem, setExpandedItem] = useState(null);

  useEffect(() => {
    setData(nextStepsData);
  }, [nextStepsData]);

  const handleToggle = (section, index) => {
    const key = `${section}-${index}`;
    setExpandedItem((prev) => (prev === key ? null : key));
  };

  const renderList = (items, section) => (
    <ul
      style={{
        fontSize: "12px",
        fontWeight: "400",
        textAlign: "left",
        paddingLeft: "0",
        marginBottom: "0px",
      }}
    >
      {items?.map((item, index) => {
        const key = `${section}-${index}`;
        const isExpanded = expandedItem === key;
        const text = typeof item === "object" ? item.value : item;

        return (
          <li
            key={key}
            className={`custom_list ${isExpanded ? "expanded" : ""} mb-2`}
            title="Click to see more"
            style={{
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: "400",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: isExpanded ? "unset" : 3,
              WebkitBoxOrient: "vertical",
            }}
            onClick={() => handleToggle(section, index)}
          >
            <span className="mr-2">•</span>
            {text?.length > 0 &&
              formatBoldText(<ParsedTextWithLinks text={text} />)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      <div className="company_overview_head_block">
        <div className="compnay_subblock_left">
          <h6 className="company_overview_head"></h6>
          <p className="compnay_overview_para" style={{ maxWidth: "100%" }}></p>
        </div>
        {/* <TopRightActionLinks actions={actions} section_type="company" /> */}
      </div>

      <div className="insight_block">
        <h5 className="insight_head">Executive Summary & Next Steps</h5>
        <div className="row">
          {/* Critical Decision Window */}
          <div className="col-md-12 mb-4">
            <div className="card_block negative">
              <h6 className="head negative_head">
                Critical Decision Window: 6-18 Months
              </h6>
              {data[0]?.response?.critical_decision_window?.length > 0 &&
                renderList(
                  data[0]?.response?.critical_decision_window,
                  "critical"
                )}
            </div>
          </div>

          {/* Market Opportunities */}
          <div className="col-md-4">
            <div className="card_block positive">
              <h6 className="head green_head">Market Opportunities</h6>
              {data[0]?.response?.market_opportunities?.length > 0 &&
                renderList(data[0]?.response?.market_opportunities, "market")}
            </div>
          </div>

          {/* Defensive Measures */}
          <div className="col-md-4">
            <div className="card_block neutral">
              <h6 className="head neutral_head">Defensive Measures</h6>
              {data[0]?.response?.defensive_measures?.length > 0 &&
                renderList(data[0]?.response?.defensive_measures, "defensive")}
            </div>
          </div>

          {/* Intelligence Tracking */}
          <div className="col-md-4">
            <div className="card_block negative">
              <h6 className="head negative_head">Intelligence Tracking</h6>
              {data[0]?.response?.intelligence_tracking?.length > 0 &&
                renderList(
                  data[0]?.response?.intelligence_tracking,
                  "intelligence"
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExecutiveSummaryNextSteps;
